import { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { getIsScoreRevealAnimationVisible, getIsKukariScoreVisible } from '../../../store/selectors/ludoboardSelectors';
import { hideKukariScore, showKukariScore, hideScoreRevealAnimation } from '../../../store/actions/ludoboardActions';
import clsx from 'clsx';
import styles from './styles.module.css';
import { getWidth } from '../../../utils/relativeSizes';

const ANIMATION_TIMINGS = {
  FIRST_SHOW: 1000,
  FIRST_HIDE: 2500,
  SECOND_SHOW: 3500,
  SECOND_HIDE: 5000,
  TOTAL_DURATION: 5500
} as const;

function KukariRevealAnimation() {
  const dispatch = useDispatch();
  const timeoutRefs = useRef<NodeJS.Timeout[]>([]);
  const isScoreRevealAnimationVisible = useSelector(getIsScoreRevealAnimationVisible);
  const isKukariScoreVisible = useSelector(getIsKukariScoreVisible);

  useEffect(() => {
    if (isScoreRevealAnimationVisible) {
      // Clear any existing timeouts first
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
      // Setup new animation sequence
      const timeouts = [
        setTimeout(() => {
          dispatch(showKukariScore());
        }, ANIMATION_TIMINGS.FIRST_SHOW),
        setTimeout(() => {
          dispatch(hideKukariScore());
        }, ANIMATION_TIMINGS.FIRST_HIDE),
        setTimeout(() => {
          dispatch(showKukariScore());
        }, ANIMATION_TIMINGS.SECOND_SHOW),
        setTimeout(() => {
          dispatch(hideKukariScore());
        }, ANIMATION_TIMINGS.SECOND_HIDE),
        setTimeout(() => {
          dispatch(hideScoreRevealAnimation());
        }, ANIMATION_TIMINGS.TOTAL_DURATION)
      ];

      // Store timeout refs for cleanup
      timeoutRefs.current = timeouts;
    }

    // Cleanup function
    return () => {
      timeoutRefs.current.forEach(timeout => clearTimeout(timeout));
      timeoutRefs.current = [];
    };
  }, [isScoreRevealAnimationVisible, dispatch]);

  if (!isScoreRevealAnimationVisible) {
    return null;
  }

  return (
    <div className={clsx(styles.animationContainer, "absolute flex alignItemCenter justifyContentCenter")}
      style={{
        width: getWidth(360),
        height: getWidth(380),
        zIndex: 1000
      }}>
    </div>
  );
}

export default KukariRevealAnimation;
